import { SvgIcon } from "@material-ui/core";

export const Menu = (props) => (
    <SvgIcon {...props} viewBox="-3 -6 24 24">
      <path xmlns="http://www.w3.org/2000/svg" d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z" fill="currentColor"/>
    </SvgIcon>
  );
